import type { HttpClient } from '@angular/common/http';

import { Environment } from '../../environments/environment';

export interface GetRequestOptions {
  headers?: Record<string, string>;
  priority?: 'auto' | 'high' | 'low';
  queryParams?: Record<string, number | string>;
}

export async function GetRequest<T>(
  http: HttpClient,
  url: string,
  params?: GetRequestOptions,
): Promise<T> {
  // Initialize params if not provided.
  params ??= {};

  // Add headers from params if provided.
  params.headers ??= {};

  // Add the default headers if they are not already provided in params.
  if (!params.headers.Authorization) {
    params.headers.Authorization = Environment.basicToken;
  }
  if (!params.headers['Content-Type']) {
    params.headers['Content-Type'] = 'application/json';
  }

  // Add the priority if provided, default to 'auto'.
  params.priority ??= 'auto';

  // Add the query parameters to the URL if provided.
  if (params.queryParams) {
    const _queryString = Object.entries(params.queryParams)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    url += `?${_queryString}`;
  }

  return new Promise<T>((resolve, reject) => {
    http.get<T>(url, params).subscribe({
      error: (error: Error) => {
        reject(error);
      },
      next: (response) => {
        resolve(response);
      },
    });
  });
}
